<template lang="pug">
  div
    v-layout(align-center justify-space-between)
      span(class="headline") Franchises
      span(class="caption")
        | You can create a franchise from a subcontractor.

    v-container

      template(v-if="loading")
        v-layout(class="mt-5" justify-center)
          v-progress-circular(size="50" indeterminate)

      template(v-else-if="franchises.length === 0")
        v-layout(class="mt-5" justify-center)
          span(class="title") No franchises.

      template(v-else)
        v-data-table(:headers="headers" :items="franchises" hide-actions)
          template(slot="items" slot-scope="props")
            tr
              td
                router-link(
                  :to="{ name: 'franchise',\
                         params: { id: props.item.id } }"
                  class="clickable") {{ props.item.name }}
              td
                router-link(
                  :to="{ name: 'subcontractor',\
                         params: { id: props.item.subcontractor.id } }"
                  class="clickable") {{ props.item.subcontractor.name }}
              td {{ props.item.details | filterPhone }}
              td {{ props.item.details | filterAddress }}
              td(class="text-xs-center") {{ props.item.rating | displayRating }}
          template(slot="no-data")
            v-container
              v-layout
                v-flex Please add a franchise from its subcontractor page

</template>

<script>
export default {
  filters: {
    displayRating (rating) {
      return rating ? parseFloat(rating).toFixed(1) : "";
    },
    filterAddress (details) {
      let filtered = details.filter((d) => d.immutable === "address");
      if (filtered.length > 0) {
        return filtered[0].value;
      }
      return "";
    },
    filterPhone (details) {
      let filtered = details.filter((d) => d.immutable === "phone");
      if (filtered.length > 0) {
        return filtered[0].value;
      }
      return "";
    }
  },
  data () {
    return {
      headers: [
        {
          text: "Name",
          value: "name",
          width: "20%"
        },
        {
          text: "Subcontractor",
          value: "subcontractor.name",
          width: "20%"
        },
        {
          text: "Phone number",
          value: "phone",
          sortable: false,
          width: "20%"
        },
        {
          text: "Address",
          value: "address",
          sortable: false
        },
        {
          text: "Rating",
          value: "rating",
          align: "center",
          width: "10%"
        }
      ],
      loading: false,
      franchises: []
    };
  },
  created () {
    this.loading = true;
    this.$http.get("/api/franchises").
      then((r) => {
        this.loading = false;
        this.franchises = Array.from(r.data);
      }).
      catch(() => this.loading = false);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Franchises.vue